'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "children", "semanticColor", "isHover", "isFocus", "isActive"];
import React, { useContext } from 'react';
import { KeyboardDetectionContext } from "../../contexts/KeyboardDetectionContext.mjs";
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { VisuallyHidden } from "../VisuallyHidden/index.mjs";
import { Indicator } from "./Indicator.mjs";
import { Label } from "./Label.mjs";
import { Radio } from "./Radio.mjs";
import { TextForLabel } from "./TextForLabel.mjs";
export var FormRadio = /*#__PURE__*/React.forwardRef(function FormRadio(_ref, ref) {
  var id = _ref.id,
    children = _ref.children,
    _ref$semanticColor = _ref.semanticColor,
    semanticColor = _ref$semanticColor === void 0 ? 'essentialBrightAccent' : _ref$semanticColor,
    isHover = _ref.isHover,
    isFocus = _ref.isFocus,
    isActive = _ref.isActive,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useContext = useContext(KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  return /*#__PURE__*/React.createElement(Radio, {
    "data-encore-id": ENCORE_DATA_IDS.FormRadio
  }, /*#__PURE__*/React.createElement(VisuallyHidden, Object.assign({
    component: "input",
    type: "radio",
    ref: ref,
    id: id
  }, props)), /*#__PURE__*/React.createElement(Label, {
    htmlFor: id
  }, /*#__PURE__*/React.createElement(Indicator, {
    $isUsingKeyboard: isUsingKeyboard,
    $semanticColor: semanticColor,
    $isHover: isHover,
    $isFocus: isFocus,
    $isActive: isActive
  }), children && /*#__PURE__*/React.createElement(TextForLabel, null, children)));
});